import { HelpOutline } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import React from "react";
import { StyledHeader } from "../../styled/layout";

const IconToJira = () => {
  const handleClickHelp = () => {
    window.open(
      "https://accessinformatica.atlassian.net/servicedesk/customer/portals",
    );
  };

  return (
    <React.Fragment>
      <StyledHeader.OptionsIconContainer>
        <Tooltip title="Ayuda" arrow>
          <StyledHeader.HeaderIcon size="small" onClick={handleClickHelp}>
            <HelpOutline />
          </StyledHeader.HeaderIcon>
        </Tooltip>
      </StyledHeader.OptionsIconContainer>
    </React.Fragment>
  );
};

export default IconToJira;
